import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

export interface SelectItemProps {
    value: any;
    onClick?: () => void;
    children: ReactNode;
    className?: string;
}

const StyledSelectItem = styled.div`
    display: flex;
    align-items: center;
    padding: 8px;
    cursor: pointer;
    ${({ theme: { colors, typography } }) => `
        color: ${colors.text.primary};
        font-size: ${typography.size.desktop.paragraph.p3};
        line-height: calc(${typography.lineHeight[2]} - 1px);
        &:hover,
        &.selected {
            background-color: ${colors.background.secondary.v4};
            color: ${colors.primary};
        }
    `}
`;

// eslint-disable-next-line no-unused-vars
const SelectItem: FC<SelectItemProps> = ({ value, onClick, children, className }) => {
    return (
        <StyledSelectItem className={classNames('select-item', className)} onClick={onClick}>
            {children}
        </StyledSelectItem>
    );
};

export default SelectItem;
